import { render, staticRenderFns } from "./ApplicationRowComponent.vue?vue&type=template&id=15ddb810&scoped=true"
import script from "./ApplicationRowComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationRowComponent.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRowComponent.vue?vue&type=style&index=0&id=15ddb810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ddb810",
  null
  
)

export default component.exports